import React from 'react'
// TODO move ui
// import { CheckList, Heading } from '@brainstud/schiphol-vtc-ui'

const QuizHelpQuiz = props => (
  <React.Fragment>
    <Heading h3>Spelregels</Heading>
    <CheckList list={[
      'De oefentoets is optioneel; je hoeft deze niet te maken',
      'Wanneer je op ‘Controleer’ drukt, kun je jouw antwoord controleren',
      'Je kunt je antwoorden niet meer aanpassen, nadat je deze gecontroleerd hebt',
      'Je hoeft deze oefentoets niet met een voldoende af te sluiten',
    ]} />
  </React.Fragment>
)

const QuizHelpEndtest = props => (
  <React.Fragment>
    <Heading h3>Spelregels</Heading>
    <CheckList list={[
      'De eindtoets is verplicht; je moet deze maken om de e-learning af te ronden',
      `Je moet een voldoende halen. Daarvoor moet je minimaal ${props.quiz.scoreToPass || 0} van de ${props.progress.totalQuestions || 0} vragen goed beantwoorden`,
      'Je kunt je antwoorden tot het eind van de toets aanpassen',
      'Je mag de eindtoets meerdere keren maken',
      'Je moet alle vragen beantwoorden',
    ]} />
  </React.Fragment>
)

export default {
  quiz: QuizHelpQuiz,
  endtest: QuizHelpEndtest,
}
